import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language.service';

@Pipe({
  name: 'ordinalNumber'
})
export class OrdinalNumberPipe implements PipeTransform {

  private genericOrdinal = "º";

  constructor(public langService: LanguageService) {
  }

  transform(value: number, args?: any): string {
    let ordinal;

    if (this.langService.current().code.indexOf("en-") > -1) {

      const j = value % 10;
      const k = value % 100;

      if (j == 1 && k != 11)
        ordinal = "st";
      else if (j == 2 && k != 12)
        ordinal = "nd";
      else if (j == 3 && k != 13)
        ordinal = "rd";
      else
        ordinal = "th";

    } else {
      ordinal = this.genericOrdinal;
    }

    return ordinal;
  }

}
